import React from 'react'

import { AsyncSelect, Form, Col, Button } from '_zari/core'

import { NuevoProveedorModal } from 'sharedComponents/modals'
import { ClearInputGroup } from 'sharedComponents/utils'

import * as SocioCrud from 'services/socio.service'

const ProveedorFormGroup = ({ fIsSubmitting, iValue, values, setValues }) => {
  const [mostrarNuevoSocioModal, setMostrarNuevoSocioModal] = React.useState(false)

  const loadSociosSelect = (inputValue, resolve) => {
    SocioCrud.obtenerProveedoresxBusquedaAsSelect2({
      busqueda: inputValue,
      tipoSalida: 'codigo-ruc'
    }).then(({ data }) => resolve(data))
  }

  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.codigoSocio = data.codigo
      values.documentoSocio = data.numeroDocumento
      values.tipoDocumentoSocio = data.tipoDocumento
      values.nombreSocio = data.razonSocial

      setValues(values)
    })
  }

  const clickMostrarNuevoSocioModalHandler = e => {
    e.preventDefault()
    setMostrarNuevoSocioModal(true)
  }

  const seleccionarSocioCreadoHandler = socioCreado => {
    setMostrarNuevoSocioModal(false)
    values._idSocio = socioCreado._id
    values.nombreSocio = socioCreado.razonSocial
    values.codigoSocio = socioCreado.codigo
    values.documentoSocio = socioCreado.numeroDocumento
    values.tipoDocumentoSocio = socioCreado.tipoDocumento

    setValues(values)
  }

  const clickClear = () => {
    values._idSocio = ''
    values.nombreSocio = ''
    values.codigoSocio = ''
    values.documentoSocio = ''
    values.tipoDocumentoSocio = ''

    setValues(values)
  }
  return (
    <>
      <Form.Group>
        <Form.Label text='PROVEEDOR' htmlFor='input-codigoRucSocio' md={3} alignRightAt='md' />
        <Col md={9}>
          {values._idSocio ? (
            <ClearInputGroup
              id='input-codigoRucSocio'
              iValue={`${values.documentoSocio} - ${values.nombreSocio}`}
              clickClear={clickClear}
            />
          ) : (
            <Form.InputGroup>
              <AsyncSelect selectId='codigoRucSelect' loadOptions={loadSociosSelect} onChange={onChangeSocioHandler} />
              <Form.InputGroup.Append>
                <Button disabled={fIsSubmitting} onClick={clickMostrarNuevoSocioModalHandler}>
                  &#x2b;
                </Button>
              </Form.InputGroup.Append>
            </Form.InputGroup>
          )}
        </Col>
      </Form.Group>
      {mostrarNuevoSocioModal && (
        <NuevoProveedorModal
          handleClose={e => setMostrarNuevoSocioModal(false)}
          show={mostrarNuevoSocioModal}
          onCreate={seleccionarSocioCreadoHandler}
        />
      )}
    </>
  )
}

export default React.memo(ProveedorFormGroup)
